/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Try_Banner_CtaInputs */

const en_try_banner_cta = /** @type {(inputs: Try_Banner_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Try the app`)
};

const es_try_banner_cta = /** @type {(inputs: Try_Banner_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prueba la app`)
};

/**
* | output |
* | --- |
* | "Try the app" |
*
* @param {Try_Banner_CtaInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const try_banner_cta = /** @type {((inputs?: Try_Banner_CtaInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Try_Banner_CtaInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_try_banner_cta(inputs)
	return en_try_banner_cta(inputs)
});